import { combineReducers } from "@reduxjs/toolkit"
import swayamReducer from "./swayam"

const externalReducer = combineReducers({
  swayam: swayamReducer,
})

export default externalReducer
